// Pure decision helper for the location autocomplete: whether selecting a
// Google Places result should populate the "Location Name" (location_caption)
// field.
//
// - Default behavior (fillWhenBlank = false): always populate. This preserves
//   the long-standing behavior on the Event forms and the event wizard.
// - Activity behavior (fillWhenBlank = true): only populate when the caption is
//   currently blank, so an organizer's edited Location Name is never clobbered
//   by a later address selection.
//
// Authored as CommonJS so it can be unit-tested with Node's built-in test
// runner (the repo has no JS test framework) while remaining importable by the
// Vue component through the webpack/babel ESM interop.

function hasText(value) {
  return value != null && String(value).trim() !== "";
}

function shouldFillCaption({ fillWhenBlank, currentCaption }) {
  if (!fillWhenBlank) return true;

  return !hasText(currentCaption);
}

module.exports = { hasText, shouldFillCaption };
